// src/services/joinLink.js
//
// Partner share links carry a live session code in the path
// (/assessment/values-alignment/join/ABCD2345). Analytics page views record
// the page URL, so the code is moved out of the address bar before analytics
// starts: stashJoinCodeFromUrl() runs in main.jsx ahead of startAnalytics(),
// keeps the code for this tab, and replaces the URL with the code-free
// /assessment/values-alignment/join. The join screen then reads it back with
// takeJoinCode().

export const JOIN_PATH = '/assessment/values-alignment/join';
const JOIN_WITH_CODE = /^\/assessment\/values-alignment\/join\/([^/?#]+)\/?$/i;
const STASH_KEY = 'relationshipCompass_pendingJoinCode';

let pendingCode = null;

export function stashJoinCodeFromUrl() {
  if (typeof window === 'undefined') return;
  const match = window.location.pathname.match(JOIN_WITH_CODE);
  if (!match) return;

  let code = match[1];
  try {
    code = decodeURIComponent(code);
  } catch {
    /* keep the raw segment */
  }
  pendingCode = code;
  try {
    sessionStorage.setItem(STASH_KEY, code);
  } catch {
    /* private browsing — the in-memory copy still covers this page load */
  }
  window.history.replaceState(
    window.history.state,
    '',
    JOIN_PATH + window.location.search + window.location.hash
  );
}

/** The join code from the link this tab arrived on, or null. */
export function takeJoinCode() {
  if (pendingCode) return pendingCode;
  try {
    return sessionStorage.getItem(STASH_KEY);
  } catch {
    return null;
  }
}
